export default __webpack_public_path__ + "static/media/logo-visa.9a2f7453.svg";